/**
 * Bus-specific general validations for passenger selection
 * İmza: (values, incrementValues, settings) => { errors }
 */
export const busPassengerGeneralValidations = (values, incrementValues, settings) => {
  const errors = {};

  const total = Object.values(incrementValues).reduce(
    (sum, val) => sum + (typeof val === "number" ? val : 0),
    0,
  );

  // Total max
  if (settings?.totalSelections !== undefined && total > settings.totalSelections) {
    errors.general = {
      titleKey: "bus.passengerMaxTitle",
      descriptionKey: "bus.passengerMaxDescription",
    };
  }

  // Total min
  if (settings?.minTotalSelections !== undefined && total < settings.minTotalSelections) {
    errors.general = {
      titleKey: "bus.passengerMinTitle",
      descriptionKey: "bus.passengerMinDescription",
    };
  }

  // Bebek > Yetişkin değil - (otobüste infant türü olmayabilir, örnek kural)
  if (
    incrementValues?.infant !== undefined &&
    incrementValues?.adult !== undefined &&
    incrementValues.infant > incrementValues.adult
  ) {
    errors.general = {
      titleKey: "bus.passengerInfantAdultTitle",
      descriptionKey: "bus.passengerInfantAdultDescription",
    };
  }

  return { errors };
};


